function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P8 = function P8(_ref) {
  var page = _ref.page;
  var thisPage = 4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, [0, 1, 2, 3, 4].map(function (x) {
    return /*#__PURE__*/React.createElement(Row, {
      nr: x,
      page: page,
      thisPage: thisPage,
      key: "p8".concat(x)
    });
  }));
};
export default P8;
var Row = function Row(_ref2) {
  var nr = _ref2.nr,
    page = _ref2.page,
    thisPage = _ref2.thisPage;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $(".p8-row__".concat(nr)).addClass("p8-row__".concat(nr, "--active"));
      }, 2500 + nr * 750)]);
    } else {
      $(".p8-row__".concat(nr)).removeClass("p8-row__".concat(nr, "--active"));
    }
  }, [page]);
  var txt = {
    0: 'lowers-the-carbon-footprint@3x.png',
    1: 'lowers-the-cost-of-waste-disposal@3x.png',
    2: 'minimizes-waste-to-landfills@3x.png',
    3: 'reduces-consumption-of-virgin-material@3x.png',
    4: 'decreases-transportation-costs@3x.png'
  };
  var icon = {
    0: 'icon-carbon-footprint@3x.png',
    1: 'icon-waste-cost@3x.png',
    2: 'icon-landfill-waste@3x.png',
    3: 'icon-virgin-material@3x.png',
    4: 'icon-truck@3x.png'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p8-row p8-row__".concat(nr)
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/down-arrow@3x.png",
    className: "p8-row__a"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/".concat(icon[nr]),
    className: "p8-row__i".concat(nr)
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/".concat(txt[nr]),
    className: "p8-row__t".concat(nr)
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p8/blurb-bg@3x.png",
    className: "p8-row__bg"
  }));
};